import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'

import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'

import { useRef } from 'react'
import FormDatePicker from '../FormDatePicker'
import moment from 'moment'

const FormDateRangePicker = ({ formProps, itemProps, inputConfig }) => {
  const { label, disabled } = itemProps || {}
  const { field: { onChange, value } = {} } = formProps || {}

  const { onSubmit, inputBaseProps } = inputConfig
  const fragmentRef = useRef(null)

  const { startDate, endDate } = value

  // const [fromDate, setFromDate] = useState(startDate || moment())
  // const [toDate, setToDate] = useState(endDate || moment())

  const datePickerItemProps = {
    size: 'small',
    disabled,
    // InputProps: {
    //   endAdornment: (
    //     <InputAdornment position="end">
    //       <IconButton
    //         disabled={disabled}
    //         edge="end"
    //         onClick={() => {
    //           setOpen(true)
    //         }}
    //       >
    //         <DateRangeIcon />
    //       </IconButton>
    //     </InputAdornment>
    //   ),
    // },
  }

  return (
    <>
      <div ref={fragmentRef}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Grid container direction={'row'} alignItems={'center'} spacing={2}>
            <Grid item>
              <FormDatePicker
                itemProps={{
                  ...datePickerItemProps,
                  label,
                  maxdate: moment(endDate).add(-1, 'days').toDate(),
                }}
                formProps={{
                  field: {
                    value: startDate,
                    onChange: val => {
                      onChange({ startDate: val, endDate })
                    },
                  },
                }}
                inputConfig={{ inputBaseProps, sx: { width: 160 } }}
              />
            </Grid>
            <Grid item>
              <Box>~</Box>
            </Grid>
            <Grid item>
              <FormDatePicker
                itemProps={{
                  ...datePickerItemProps,
                  mindate: moment(startDate).add(1, 'days').toDate(),
                }}
                formProps={{
                  field: {
                    value: endDate,
                    onChange: val => {
                      onChange({ startDate, endDate: val })
                    },
                  },
                }}
                inputConfig={{
                  inputBaseProps,
                  sx: { width: 160 },
                  ...(onSubmit
                    ? {
                        onSubmit: () => {
                          onSubmit(value)
                        },
                      }
                    : {}),
                }}
              />
            </Grid>
          </Grid>
        </LocalizationProvider>
      </div>
    </>
  )
}

export default FormDateRangePicker
